import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../lib/settings";

const STORAGE_KEY = "wp:cookie_consent";

export default function CookieBanner() {
  const s = useSettings();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!s?.cookie_banner_enabled) return;
    try {
      if (!window.localStorage.getItem(STORAGE_KEY)) {
        // Defer a bit so it doesn't fight with the welcome banner
        const t = setTimeout(() => setOpen(true), 400);
        return () => clearTimeout(t);
      }
    } catch {
      /* localStorage blocked – just show */
      setOpen(true);
    }
  }, [s?.cookie_banner_enabled]);

  if (!open) return null;

  const accept = () => {
    try { window.localStorage.setItem(STORAGE_KEY, "accepted"); } catch { /* ignore */ }
    setOpen(false);
  };

  const text = s.cookie_banner_text || "Wir verwenden nur technisch notwendige Cookies.";
  const acceptLabel = s.cookie_banner_accept_label || "Verstanden";
  const linkLabel = s.cookie_banner_privacy_link_label || "Datenschutz";
  const linkUrl = s.cookie_banner_privacy_link_url || "/impressum";

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] border-t"
      style={{
        backgroundColor: "var(--wp-cream, #E7DED0)",
        borderColor: "var(--wp-border, rgba(0,0,0,0.08))",
        boxShadow: "0 -8px 24px rgba(0,0,0,0.08)",
      }}
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-5 py-4 md:py-5 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-5">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <span aria-hidden="true" className="text-xl select-none">🍪</span>
          <p className="text-xs sm:text-sm leading-relaxed" style={{ color: "var(--wp-forest, #3A392C)" }} data-testid="cookie-banner-text">
            {text}{" "}
            {linkUrl && (
              <Link to={linkUrl} className="underline hover:no-underline" data-testid="cookie-banner-link">
                {linkLabel}
              </Link>
            )}
          </p>
        </div>
        <button
          type="button"
          onClick={accept}
          className="shrink-0 inline-flex items-center justify-center px-5 py-2 rounded-full text-sm font-medium transition-colors hover:opacity-90"
          style={{ backgroundColor: "var(--wp-olive, #5F5B3E)", color: "var(--wp-cream, #F5F0E8)" }}
          data-testid="cookie-banner-accept"
        >
          {acceptLabel}
        </button>
      </div>
    </div>
  );
}
